import React, { useState } from 'react';
import { Container, Col, Card, Row } from 'react-bootstrap';
import projectsimg from '../images/projects-done.svg';
import smileimg from '../images/smile.svg';
import coffeeimg from '../images/coffee-breaks.svg';
// import underconstrunction from '../images/gfx-mobile-construction.svg';
import axios from 'axios';

function HomeSection() {
  const [successmsg, setSuccessmsg] = useState("");
  const [errormsg, setErrormsg] = useState("");
  const [selectedclass, setSelectedclass] = useState("custom-select border-0 bg-transparent form_fields lh-46");

  const email_validation = (email) => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

  const name_validation = (name) => {
    var letters = /^([\s\.]?[a-zA-Z]+)+$/;
    if (name.match(letters)) {
      return true;
    }
    else {
      return false;
    }
  };

  const mobile_number_validation = (mobile) => {
    var phoneno = /^\d{10}$/;
    if (mobile.match(phoneno)) {
      return true;
    }
    else {
      return false;
    }
  };

  const set_error = (fieldid) => {
    //var div_error = $('#'+fieldid).closest('div[class^="input-group"]');
    //div_error.addClass('has-error');
  };

  const alertmsg = (message, focusid) => {
    setErrormsg(message);
    if (focusid && focusid !== "") {
      document.getElementById(focusid).focus();
    }
  };

  const successmsgfn = (message) => {
    setSuccessmsg(message);
  };

  const serviceValidate = async (event) => {
    var service = document.getElementById('service').value;
    var classname = "custom-select border-0 bg-transparent form_fields lh-46";
    if (service && service !== "") {
      classname = classname + " selected";
    }
    setSelectedclass(classname);
  };

  const getQuote = async (event) => {
    event.preventDefault();

    setErrormsg("");
    setSuccessmsg("");

    var name = document.getElementById('name').value;
    var email = document.getElementById('email').value;
    var service = document.getElementById('service').value;
    var budget = document.getElementById('budget').value;
    var message = document.getElementById('message').value;

    var name_val = name_validation(name);
    var email_val = email_validation(email);

    //has error validation
    if (!name || name === "") {
      set_error("name");
    }
    if (!name_val) {
      set_error("name");
    }
    if (!email || email === "") {
      set_error("email");
    }
    if (!email_val) {
      set_error("email");
    }
    if (!service || service === "") {
      set_error("service");
    }
    if (!budget || budget === "") {
      set_error("budget");
    }
    if (!message || message === "") {
      set_error("message");
    }

    if (!name || name === "") {
      alertmsg("Name is required", "name");
    }
    else if (!name_val) {
      alertmsg("Type valid name", "name");
    }
    else if (!email || email === "") {
      alertmsg("Email id is required", "email");
    }
    else if (!email_val) {
      alertmsg("Type valid email id", "email");
    }
    else if (!service || service === "") {
      alertmsg("Service is required", "service");
    }
    else if (!budget || budget === "") {
      alertmsg("Budget is required", "budget");
    }
    else if (!message || message === "") {
      alertmsg("Message is required", "message");
    }
    else {
      const apiBase = process.env.REACT_APP_API_URL || "";
      var site_url = apiBase + "/veeyaaapi?work=getquote&name=" + encodeURIComponent(name) + "&email=" + encodeURIComponent(email) + "&service=" + encodeURIComponent(service) + "&budget=" + encodeURIComponent(budget) + "&message=" + encodeURIComponent(message);
      axios.get(site_url)
        .then(res => {
          const table_data = res.data;
          var response = table_data[0].response;
          var reason = table_data[0].reason;
          if (response === "success") {
            successmsgfn("Quote sent successfully,We will contact you shortly");
            document.getElementById("quoteForm").reset();
            var classname = "custom-select border-0 bg-transparent form_fields lh-46";
            setSelectedclass(classname);
          }
          else {
            alertmsg(reason, "");
          }
        })
        .catch(() => {
          alertmsg("Unable to send quote. Please try again or contact us directly at admin@veeyaainnovatives.com", "");
        });
    }
  };

  return (
    <div>
            {/* <div className="d-xl-none position-fixed bg-white construnction text-center justify-content-center" >
                    <div>
                    <img src={underconstrunction} alt="under construction" className="mb-4"/>
                    <h1 className="fs28">This View is Under Construction</h1>
                    <span>At the moment best to view this site in Desktop or Laptop</span>
                    </div>
                </div> */}
            <div id="home">
                <div className="cover-img position-relative" style={{ background: 'rgb(13, 95, 255)' }} >
                    {/* backgroundImage: 'url('+ bannerOne +')', */}

                    {/* Design */}
                    <div className="d-flex">
                        <div className="design-1"></div>
                        <div className="design-2"></div>
                        <div className="design-3"></div>
                        <div className="design-4"></div>
                        <div className="design-5"></div>
                        <div className="design-6"></div>
                        <div className="design-7"></div>
                    </div>


                    <div className="overlay">
                        {/* h-41rem */}
                        <Container fluid className="py-5">
                            <Row className="h-100 mt-3">
                                <Col md={10} className="mx-auto">
                                    <Row className="h-100">
                                        <Col md={12} lg={7} className="d-flex align-items-center pr-md-0">
                                            <div className="text-white mt-5">
                                                <span className="text-uppercase fs12  sub-title">We are Veeyaa Innovatives</span>
                                                <h1>Create a Great Website Fast <br /> With Us</h1>

                                                <Row className="my-5 d-none d-lg-flex">
                                                    <Col md={4}>
                                                        <div className="d-flex align-items-center h-100">
                                                            <img src={projectsimg} className="stats-icon" alt="projects" />
                                                            <div className="pl-3">
                                                                <h2 className="mb-0 fs22">30</h2>
                                                                <span className="fs14">No Of Projects</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={4} className="border-left border-right pl-4">
                                                        <div className="d-flex align-items-center h-100">
                                                            <img src={smileimg} className="stats-icon" alt="projects" />
                                                            <div className="pl-3">
                                                                <h2 className="mb-0 fs22">30</h2>
                                                                <span className="fs14">Happy Faces</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                    <Col md={4} className="pl-4">
                                                        <div className="d-flex align-items-center h-100">
                                                            <img src={coffeeimg} className="stats-icon" alt="projects" />
                                                            <div className="pl-3">
                                                                <h2 className="mb-0 fs22">100</h2>
                                                                <span className="fs14">Cup of Coffee</span>
                                                            </div>
                                                        </div>
                                                    </Col>
                                                </Row>


                                                <a href="mailto:admin@veeyaainnovatives.com" className="text-white"><em className="fas fa-envelope-open-text mr-2"></em> admin@veeyaainnovatives.com</a>

                                                {/* <button className="btn btn-cards br-20px  px-4">Contact Us</button> */}
                                            </div>
                                        </Col>
                                        <Col md={12} lg={5} className="d-flex align-items-center justify-content-center pt-4">

                                            <Card className="get-a-quote-card bg-white border-0 w-100 mt-5">
                                                <Card.Header className="bg-white border-0 pb-0 pt-3 px-4">
                                                    <h1 className="fs18 font-title op-9 mb-1 pt-2">Get a Quote</h1>
                                                    <span className="color-grey3 fs11 d-block">We will reach you in notime</span>
                                                </Card.Header>
                                                <Card.Body className="px-4 pb-4 pt-3 ">

                                                    <form className="custom-input" onSubmit={getQuote} id="quoteForm">
                                                        <div className="input-group floating-input mb-3">
                                                            <input type="text" id="name" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                                            <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Name</label>
                                                        </div>
                                                        <div className="input-group floating-input mb-3">
                                                            <input type="text" id="email" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                                            <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Email</label>
                                                        </div>
                                                        <div className="input-group floating-input mb-3">
                                                            <select className={selectedclass} onChange={serviceValidate} id="service">
                                                                <option value=""></option>
                                                                <option value="Mobile App Development">Mobile App Development</option>
                                                                <option value="Website Development">Website Development</option>
                                                                <option value="Shopping Website">Shopping Website</option>
                                                                <option value="Inventory Management system">Inventory Management system</option>
                                                            </select>
                                                            <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Service you need</label>
                                                        </div>
                                                        <div className="input-group floating-input mb-3">
                                                            <input type="number" id="budget" className="form-control border-0 bg-transparent pt-0 form_fields" placeholder=" " />
                                                            <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Your budget</label>
                                                        </div>
                                                        <div className="input-group floating-input textarea-form-input mb-3 h-auto">
                                                            <textarea id="message" className="form-control border-0 bg-transparent  form_fields" rows="3" placeholder=" " />
                                                            <label className="floating-lable d-block position-absolute px-2 pt-0 bg-white">Message</label>
                                                        </div>

                                                        <div className="fs14 mb-3 text-center">
                                                            <span className="text-danger">{errormsg}</span>
                                                            <span className="text-success">{successmsg}</span>
                                                        </div>

                                                        <Row className="text-center">
                                                            <Col md={{ span: 6, offset: 3 }}>
                                                                <button type="submit" className="btn btn-quote btn-block">
                                                                    Get Quote
                                                                </button>
                                                            </Col>
                                                        </Row>
                                                    </form>
                                                </Card.Body>
                                            </Card>
                                        </Col>

                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomeSection;
